function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveProgramTaskApi, getProgramTaskInfoApi, getProgramVersionApi, setProgramVersionApi } from '@/api/program';
import draggable from 'vuedraggable';
export default {
  name: 'addProgram',
  components: {
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    draggable: draggable
  },
  props: {
    projectList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programVersionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programMemberOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      inputs: [{
        id: '',
        name: ''
      }],
      dragging: false,
      id: 0,
      principal: [],
      type: 0,
      memberShow: false,
      onlyOne: false,
      edit: false,
      dialogVisible: false,
      timeVal: [],
      formData: {
        status: 1,
        path: []
      },
      priorityOptions: [{
        value: 1,
        label: '紧急'
      }, {
        value: 2,
        label: '高'
      }, {
        value: 3,
        label: '中'
      }, {
        value: 4,
        label: '低'
      }, {
        value: 0,
        label: '无优先级'
      }],
      rule: {
        name: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'blur'
        }],
        program_id: [{
          required: true,
          message: '请选择关联项目',
          trigger: 'change'
        }]
      },
      programId: '',
      currentPid: 0,
      content: ''
    };
  },
  watch: {
    'formData.describe': {
      handler: function handler(nVal, oVal) {
        if (nVal !== oVal) {
          this.content = nVal;
        }
      },
      deep: true
    }
  },
  methods: {
    // 设置版本
    setVersion: function setVersion() {
      this.dialogVisible = true;
      this.getVersion();
    },
    submitVersion: function submitVersion() {
      var _this = this;
      setProgramVersionApi(this.formData.program_id, {
        data: this.inputs
      }).then(function () {
        _this.dialogVisible = false;
        _this.inputs = [];
        _this.$emit('getProgramVersionList', _this.formData.program_id);
      });
    },
    // 获取版本
    getVersion: function getVersion() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getProgramVersionApi({
                program_id: _this2.formData.program_id
              });
            case 2:
              result = _context.sent;
              _this2.inputs = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCloseVersion: function handleCloseVersion() {
      this.dialogVisible = false;
      this.inputs = [];
    },
    addInput: function addInput() {
      this.inputs.push({
        id: '',
        name: ''
      });
    },
    removeInput: function removeInput(index) {
      this.inputs.splice(index, 1);
    },
    // 选择项目
    handleContract: function handleContract(eid, row) {
      this.formData.uid = '';
      this.formData.version_id = '';
      this.formData.members = [];
      this.$emit('getProgramVersionList', eid);
      this.$emit('getMemberList', eid);
      this.$emit('getProgramSelectList', row);
    },
    // 获取任务详情
    getProgramInfo: function getProgramInfo(id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getProgramTaskInfoApi(id);
            case 2:
              result = _context2.sent;
              _this3.formData.program_id = result.data.program_id;
              _this3.formData.path = result.data.path;
              _this3.formData.path.push(_this3.currentPid);
              _this3.formData.pid = _this3.currentPid;
              _this3.$emit('getProgramVersionList', result.data.program_id);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 删除标签
    cardTag: function cardTag(index) {
      this.principal.splice(index, 1);
      this.formData.uid = '';
    },
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.timeVal = '';
        this.formData.plan_start = '';
        this.formData.plan_end = '';
      } else {
        this.formData.plan_start = this.timeVal[0];
        this.formData.plan_end = this.timeVal[1];
      }
    },
    handleRemove: function handleRemove(e) {
      this.formData.path = e;
      if (e && e.length > 0) {
        this.formData.pid = e[e.length - 1];
      }
    },
    ueditorEdit: function ueditorEdit(e) {
      this.content = e;
    },
    handleClose: function handleClose() {
      this.drawer = false;
      this.reset();
      this.$refs.formData.resetFields();
    },
    openBox: function openBox(id, data) {
      this.currentPid = data.pid;
      this.formData.pid = data.pid;
      this.programId = data.program_id;
      this.content = data.describe;
      this.drawer = true;
      this.edit = id ? true : false;
      this.id = id ? id : 0;
      var result = {
        program_id: data.program_id,
        id: id
      };
      this.handleContract(this.programId, result);
      if (data) {
        this.formData = data;
        this.timeVal = this.formData.plan_start ? [this.formData.plan_start, this.formData.plan_end] : [];
        if (this.formData.admins) {
          this.principal = this.formData.admins;
          var members = [];
          members = this.principal.map(function (item) {
            return item.id;
          });
          this.formData.members = members;
        }
      }
      if (this.edit) {
        this.getProgramInfo(id);
      }
    },
    reset: function reset() {
      this.formData = {
        name: '',
        uid: '',
        pid: 0,
        path: [],
        version_id: null,
        members: [],
        plan_start: '',
        plan_end: '',
        status: null,
        priority: '',
        describe: ''
      };
      this.timeVal = [];
      this.edit = false;
      this.principal = [];
      this.content = '';
    },
    // 提交
    handleConfirm: function handleConfirm(type) {
      var _this4 = this;
      this.formData.describe = this.content;
      this.$refs.formData.validate(function (valid) {
        if (valid) {
          var data = {
            page: 1,
            limit: 15,
            types: 0,
            pid: 0,
            program_id: _this4.programId || null,
            scope_frame: 'all',
            scope_normal: 0
          };
          saveProgramTaskApi(_this4.formData).then(function (res) {
            _this4.drawer = false;
            _this4.$emit('getTableData', data);
            if (type === 1) {
              var _data = {
                program_id: _this4.formData.program_id
              };
              _this4.openBox(0, _data);
              return;
            }
            _this4.reset();
            _this4.$refs.formData.resetFields();
          });
        }
      });
    }
  }
};